/* eslint-disable */
import mixpanel from 'mixpanel-browser';
import isEmpty from 'lodash/isEmpty';

class ModsyMixpanelImp {
  constructor () {
    this.DEV_TOKEN = 'd4c0d05811771d4671fbb60fa3d8d82e';
    this.STAGING_TOKEN = 'aa6ae4fe812f59c62e415b98acf7c2aa';
    this.PRODUCTION_TOKEN = '804b08d18ad2f316389b7f26d5183541';
    this.SELF_DEBUG = true;
    this.USE_MIXPANEL = true;

    this.replacement = {};

    if (window.location.hostname.toLowerCase().search('www.modsy.com') >= 0) {
      this.SELF_DEBUG = false;
      this.__init(this.PRODUCTION_TOKEN);
    } else if (
      window.location.hostname.toLowerCase().search('staging.modsy.com') >= 0
    ) {
      this.SELF_DEBUG = false;
      this.__init(this.STAGING_TOKEN);
    } else if (this.SELF_DEBUG) {
      this.__init(this.DEV_TOKEN);
    }

    this.logout = this.logout.bind(this);
  }

  __mixpanelTrackEvent (event, params) {
    params = params || {};
    if (this.SELF_DEBUG) console.log(event, params);
    if (this.USE_MIXPANEL) {
      mixpanel.track(event, params);
    }
  }

  __init (token) {
    this.USE_MIXPANEL = false;
    mixpanel.init(token, {
      loaded: (mixpanel) => {
        this.USE_MIXPANEL = true;
      }
    });
    if (this.USE_MIXPANEL) {
      // TODO: port these events to new webapp ???
      // mixpanel.track_links('.link-retailer-buy', 'Retailer Buy Click', (ele) => {
      //   return { type: $(ele).attr('hash') };
      // });
      // mixpanel.track_links('#switch-button', 'Signup Open', {
      //   cta: 'login',
      // });
    }
  }

  set_user_info_once (info) {
    if (this.USE_MIXPANEL) {
      mixpanel.people.set_once(info);
    }
  }
  update_user_info (info) {
    // TODO: Implement this when needed (like changing user name / email etc happens)
  }
  trackSignup (
    userId,
    email,
    first_name,
    last_name,
    age_group,
    created,
    callback
  ) {
    if (this.SELF_DEBUG) {
      console.log(
        'Tracking Sign Up: ',
        userId,
        email,
        first_name,
        last_name,
        created
      );
    }
    if (this.USE_MIXPANEL) {
      mixpanel.alias(userId);
      mixpanel.identify(mixpanel.get_distinct_id());
      mixpanel.register_once({
        user_email: email,
        first_name,
        last_name
      });
      mixpanel.people.set_once({
        $first_name: first_name,
        $last_name: last_name,
        $created: created,
        $email: email,
        age_group
      });
      mixpanel.track('Sign Up', null, callback);
    }
  }
  trackLogin (
    userId,
    email,
    first_name,
    last_name,
    landing_page,
    created,
    admin
  ) {
    if (this.SELF_DEBUG) {
      console.log(
        'Tracking Login: ',
        userId,
        email,
        first_name,
        last_name,
        created,
        admin
      );
    }
    if (this.USE_MIXPANEL) {
      mixpanel.identify(userId);
      mixpanel.register_once({
        user_email: email,
        first_name,
        last_name
      });
      mixpanel.people.set_once({
        $first_name: first_name,
        $last_name: last_name,
        $created: created,
        $email: email,
        is_admin: admin
      });
      mixpanel.track('Log In', { landing_page });
    }
  }
  setLoggedin (userId, email, first_name, last_name, created, admin) {
    if (this.SELF_DEBUG) {
      console.log(
        'Get Auth: ',
        userId,
        email,
        first_name,
        last_name,
        created,
        admin
      );
    }
    if (this.USE_MIXPANEL) {
      mixpanel.identify(userId);
      mixpanel.register_once({
        user_email: email,
        first_name,
        last_name
      });
      mixpanel.people.set_once({
        $first_name: first_name,
        $last_name: last_name,
        $created: created,
        $email: email,
        is_admin: admin
      });
    }
  }
  logout () {
    if (this.SELF_DEBUG) console.log('Logged out');
    if (this.USE_MIXPANEL) {
      mixpanel.reset();
    }
  }
  trackActivate (userId, email, landing_page) {
    if (this.USE_MIXPANEL) {
      mixpanel.identify(userId);
      mixpanel.track('Activate');
    }
  }
  trackSpaceVisit (spaceId) {
    if (this.SELF_DEBUG) console.log('Tracking Space Visit: ', spaceId);
    if (this.USE_MIXPANEL) {
      mixpanel.register({ space_id: spaceId });
      mixpanel.track('Space Visit');
    }
  }
  trackSpaceVisitOther (userId, spaceId) {
    if (this.SELF_DEBUG) { console.log('Tracking Space Visit From Others: ', userId, spaceId); }
    if (this.USE_MIXPANEL) {
      mixpanel.register({ space_id: spaceId });
      mixpanel.track('Space Visit', { owner_id: userId, others_visit: true });
    }
  }
  trackSpaceVisitFromAdmin (spaceId) {
    if (this.SELF_DEBUG) { console.log('Tracking Space Visit From Admin: ', spaceId); }
    if (this.USE_MIXPANEL) {
      mixpanel.register({ space_id: spaceId });
      mixpanel.track('Space Visit (Admin)');
    }
  }
  trackAffirmLearnMoreClick ({ origin, productId, spaceId }) {
    if (this.SELF_DEBUG) console.log('Tracking Affirm Learn More Click: ', origin, productId, spaceId);
    if (this.USE_MIXPANEL) {
      mixpanel.track('Affirm: Learn More Click', { origin, productId, spaceId });
    }
  }
  trackProductBarOpen (spaceId) {
    if (this.SELF_DEBUG) { console.log('Tracking Product Side Bar Open: ', spaceId); }
    if (this.USE_MIXPANEL) {
      mixpanel.track('Product Bar Open', { space_id: spaceId });
    }
  }
  trackPdpOpen (productId, source, url, price) {
    if (this.SELF_DEBUG) { console.log('Tracking PDP View: ', productId, source, url, price); }
    if (this.USE_MIXPANEL) {
      mixpanel.track('PDP View', {
        product_id: productId,
        source,
        url,
        price
      });
    }
  }
  trackBuyFromRetailer (productId, source, url, price, cb) {
    if (this.SELF_DEBUG) { console.log('Buy from Retailer: ', productId, source, url, price); }
    if (this.USE_MIXPANEL) {
      mixpanel.track('Buy from Retailer', {
        product_id: productId,
        source,
        url,
        price
      });
      setTimeout(cb, 500);
    }
  }
  trackBuyFromModsy (productId, source, url, price) {
    if (this.SELF_DEBUG) { console.log('Tracking Buy From Modsy: ', productId, source, url, price); }
    if (this.USE_MIXPANEL) {
      mixpanel.track('Buy via Modsy', {
        product_id: productId,
        source,
        url,
        price
      });
    }
  }
  trackReplaceClick (productId, altProductId) {
    if (this.SELF_DEBUG) { console.log('Tracking Replace Click: ', productId, altProductId); }
    if (this.USE_MIXPANEL) {
      if (productId && altProductId) {
        mixpanel.track('Replace Click w/ Alt Product', {
          product_id: productId,
          alt_product_id: altProductId
        });
        this.replacement[productId] = altProductId;
      } else if (productId) {
        mixpanel.track('Replace Click From PDP', {
          product_id: productId,
          alt_product_id: altProductId
        });
      } else {
        mixpanel.track('Replace Click From Studio', {
          details: this.replacement
        });
      }
    }
  }
  addToReplacement (productId, altProductId) {
    this.replacement[productId] = altProductId;
    if (this.SELF_DEBUG) { console.log('Tracking add replacement: ', productId, altProductId); }
  }

  removeFromReplacement (altProductId) {
    const k = altProductId.toString();
    if (this.replacement.hasOwnProperty(k)) {
      delete this.replacement[k];
      if (this.SELF_DEBUG) { console.log('Tracking remove replacement ', altProductId); }
    }
  }
  trackReplaceReview () {
    if (this.SELF_DEBUG) { console.log('Tracking Replace Review ', this.replacement); }
    if (this.USE_MIXPANEL) {
      mixpanel.track('Replace Review', { details: this.replacement });
    }
  }
  trackReplaceSubmit (success, reason) {
    if (this.SELF_DEBUG) { console.log('Tracking Replace Submit ', this.replacement); }
    const title = success
      ? 'Replace Submit (Success)'
      : 'Replace Submit (Failed)';
    const properties = success
      ? { details: this.replacement }
      : { reason };
    if (this.USE_MIXPANEL) {
      mixpanel.track(title, properties);
    }
  }
  trackDesignNav (designIndex, extra) {
    if (this.SELF_DEBUG) { console.log('Tracking Design Navigation ', designIndex); }
    if (this.USE_MIXPANEL) {
      mixpanel.track('Design Selected', { index: designIndex + 1 });
    }
  }
  trackEditClick (spaceId, designData) {
    if (this.SELF_DEBUG) console.log('Studio: Edit Click');
    if (this.USE_MIXPANEL) {
      var data = {space_id: spaceId}
      if (!isEmpty(designData)) {
        data = Object.assign(data, designData);
      }
      mixpanel.track('Studio: Edit Click', data);
    }
  }
  trackAddToCart (productId, source, url, price) {
    if (this.SELF_DEBUG) console.log('Tracking add to cart ', productId);
    if (this.USE_MIXPANEL) {
      mixpanel.track('Add to Cart', {
        productId,
        source,
        url,
        price
      });
    }
  }
  trackRemoveFromCart (productId, source, url, price) {
    if (this.SELF_DEBUG) console.log('Tracking remove from cart ', productId);
    if (this.USE_MIXPANEL) {
      mixpanel.track('Remove from Cart', {
        productId,
        source,
        url,
        price
      });
    }
  }
  trackCartVisit () {
    if (this.SELF_DEBUG) console.log('Visited Cart');
    if (this.USE_MIXPANEL) {
      mixpanel.track('Cart Visit');
    }
  }
  trackReviewBillingInfo () {
    if (this.SELF_DEBUG) console.log('Reviewing Billing Info');
    if (this.USE_MIXPANEL) {
      mixpanel.track('Review Billing Info');
    }
  }
  trackOrderFail (errorMessage) {
    if (this.SELF_DEBUG) console.log('Submit order Fail');
    if (this.USE_MIXPANEL) {
      mixpanel.track('Order Fail', {
        reason: errorMessage
      });
    }
  }
  trackCouponFail (errorMessage) {
    if (this.SELF_DEBUG) console.log('Coupon fail');
    if (this.USE_MIXPANEL) {
      mixpanel.track('Coupon Fail', {
        reason: errorMessage
      });
    }
  }
  trackOrderSuccess (orderNum, total) {
    if (this.SELF_DEBUG) console.log('Order Success ', orderNum, total);
    if (this.USE_MIXPANEL) {
      mixpanel.track('Order Success', {
        orderNum,
        total
      });
    }
  }
  trackDashboardVisit (spaceId) {
    if (this.SELF_DEBUG) console.log('Dashboard Visit: ', spaceId);
    if (this.USE_MIXPANEL) {
      mixpanel.track('Dashboard Visit', {
        spaceId
      });
    }
  }

  trackQuestionSubmit (step, payload) {
    if (this.SELF_DEBUG) console.log(`Question submitted: (${step})`, payload);
    if (this.USE_MIXPANEL) {
      mixpanel.track(`Question submitted: (${step})`, payload);
    }
  }

  trackStyleQuizPageView (step) {
    if (this.SELF_DEBUG) console.log('StyleQuiz Page View: ', step);
    if (this.USE_MIXPANEL) {
      mixpanel.track('StyleQuiz Page View: ', {
        step
      });
    }
  }

  trackTakeStyleQuiz (spaceId) {
    if (this.SELF_DEBUG) console.log('Take StyleQuiz: ', spaceId);
    if (this.USE_MIXPANEL) {
      mixpanel.track('Take StyleQuiz(Dashboard)', {
        spaceId
      });
    }
  }

  trackRetakeStyleQuiz (spaceId) {
    if (this.SELF_DEBUG) console.log('Retake StyleQuiz: ', spaceId);
    if (this.USE_MIXPANEL) {
      mixpanel.track('StyleQuiz Retake(Dashboard)', {
        spaceId
      });
    }
  }

  trackUploadPhotos (status, spaceId, uploadCount, reason) {
    if (status === 'begin') {
      this.photoUploadBegin = Date.now();
    }
    if (status === 'ready') {
      this.photoUploadReady = Date.now();
    }
    let timeTaken = Date.now() - this.photoUploadBegin
    if (status === 'success' || status === 'failure') {
      timeTaken = Date.now() - this.photoUploadReady
    }

    if (this.SELF_DEBUG) { console.log('Upload Photos - ' + status, spaceId, uploadCount, timeTaken, reason); }
    if (this.USE_MIXPANEL) {
      mixpanel.track('Upload Photos', {
        spaceId,
        numPhotos: uploadCount,
        timeTaken,
        status,
        reason
      });
    }
  }

  trackSubmitMeasurements (spaceId, success) {
    if (this.SELF_DEBUG) {
      console.log(
        'Submit Measurements: ',
        success ? 'success ' : 'fail ',
        spaceId
      );
    }
    if (this.USE_MIXPANEL) {
      if (success) {
        mixpanel.track('Submit Measurements(Success)', {
          spaceId
        });
      } else {
        mixpanel.track('Submit Measurements(Fail)', {
          spaceId
        });
      }
    }
  }

  trackInProgressVisit (spaceId) {
    if (this.SELF_DEBUG) console.log('InProgress Visit: ', spaceId);
    if (this.USE_MIXPANEL) {
      mixpanel.track('InProgress Visit', {
        spaceId
      });
    }
  }

  trackMoodboardVisit (spaceId) {
    if (this.SELF_DEBUG) console.log('Moodboard Visit: ', spaceId);
    if (this.USE_MIXPANEL) {
      mixpanel.track('Moodboard Visit', {
        spaceId
      });
    }
  }

  moodboardReplaceReset () {
    console.log('Moodboard reseting replacement list');
    this.replacement = {};
  }

  moodboardProductAdd (spaceId, productId) {
    if (this.SELF_DEBUG) console.log('Moodboard Product add: ', productId);
    if (this.USE_MIXPANEL) {
      mixpanel.track('Moodboard Product Add', {
        spaceId,
        productId
      });
    }
  }

  moodboardProductRemove (spaceId, productId) {
    if (this.SELF_DEBUG) console.log('Moodboard Product Remove: ', productId);
    if (this.USE_MIXPANEL) {
      mixpanel.track('Moodboard Product Remove', {
        spaceId,
        productId
      });
    }
  }

  moodboardProductReplace (spaceId, replacedId, newProductId) {
    if (this.SELF_DEBUG) {
      console.log(
        'Moodboard Product Replace: ',
        replacedId,
        ' new: ',
        newProductId
      );
    }
    if (this.USE_MIXPANEL) {
      mixpanel.track('Moodboard Product Replace', {
        spaceId,
        replacedProduct: replacedId,
        newProduct: newProductId
      });
    }
  }

  submitMoodboard (spaceId, success) {
    if (this.SELF_DEBUG) console.log('Moodboard Submit: ', spaceId);
    if (this.USE_MIXPANEL) {
      if (success) {
        mixpanel.track('Moodboard Submit(success)', {
          spaceId
        });
      } else {
        mixpanel.track('Moodboard Submit(fail)', {
          spaceId
        });
      }
    }
  }

  trackSignupOpen (cta) {
    if (this.SELF_DEBUG) console.log('Opened signup popup: ', cta);
    if (this.USE_MIXPANEL) {
      mixpanel.track('Signup Open', {
        cta
      });
    }
  }

  trackPackageLandingView () {
    this.__mixpanelTrackEvent('Package Landing Page View');
  }
  trackProjectQuestionsView () {
    this.__mixpanelTrackEvent('Project Questions Page View');
  }
  trackPackageCartView () {
    this.__mixpanelTrackEvent('Package Cart Page View');
  }
  trackNextStepsToOnBoardingClick () {
    this.__mixpanelTrackEvent('Next Steps to On Boarding Click');
  }

  // Track generic page view-- syntax per Mixpanel's recommendation
  // https://mixpanel.com/help/questions/articles/why-measure-events-vs-page-views
  trackPageView () {
    this.__mixpanelTrackEvent('Page View', { url: window.location.pathname });
  }

  // Style quiz events
  selectRoomsComplete () {
    this.__mixpanelTrackEvent('SQ1:Select Rooms', {});
  }

  selectProductsComplete (step) {
    if (!step || step === 0) {
      return;
    }
    this.__mixpanelTrackEvent(`SQ${step + 1}:Room${step} Products`, {});
  }

  selectUrgencyComplete (ans) {
    if (this.SELF_DEBUG) console.log('StyleQuiz Project Urgency: ', ans);
    if (this.USE_MIXPANEL) {
      mixpanel.track('StyleQuiz Project Urgency', {
        ans
      });
    }
  }

  userInfoComplete () {
    this.__mixpanelTrackEvent('SQ5:Questions', {});
  }

  trackQuizPoll (email, choice) {
    this.__mixpanelTrackEvent('Style Quiz Satisfaction', {
      choice,
      user_email: email
    });
  }

  trackQuizResult (email, styleResult, style_1, style_2, zipcode, age) {
    this.__mixpanelTrackEvent('Style Quiz Result', {
      user_email: email,
      style_result: styleResult,
      style_1,
      style_2
    });
    if (window.fbq) {
      window.fbq('trackCustom', 'StyleQuizCompleted', {
        email,
        zipCode: zipcode,
        age
      });
    }
  }

  trackGoToShop (email) {
    this.__mixpanelTrackEvent('Initiate Checkout', { user_email: email });
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  }

  trackPackageFAQ (itemName) {
    if (this.SELF_DEBUG) console.log('Common Question open: ', itemName);
    if (this.USE_MIXPANEL) {
      mixpanel.track('Common Questions', {
        itemName
      });
    }
  }

  trackPackagePurchaseClick () {
    if (this.SELF_DEBUG) console.log('Purchase clicked: ');
    if (this.USE_MIXPANEL) {
      mixpanel.track('Purchase clicked', {});
    }
  }

  headerClick (linkName) {
    this.__mixpanelTrackEvent('Website Header Click', {
      'Link Name': linkName
    });
  }

  homepageHeroPrimaryCta () {
    this.__mixpanelTrackEvent('Hero Primary CTA Click', {});
  }

  homepageHeroSecondaryCta () {
    this.__mixpanelTrackEvent('Hero Secondary CTA Click', {});
  }

  styleQuizResultAction (to, spaceId, email) {
    this.__mixpanelTrackEvent('StyleQuiz Result Action', { to });
    if (spaceId) this.trackGoToShop(email);
  }

  postPurchaseCartThankYou () {
    this.__mixpanelTrackEvent('Post purchase cart Thank you page');
  }

  modsyBuyInfoCTA () {
    this.__mixpanelTrackEvent('Learn more about Modsy Buy CTA Click');
  }
  modsyProjectQuestionsDontSeeYourRoom () {
    this.__mixpanelTrackEvent('Dont see your room link Click');
  }
  modsyProjectQuestionSelectRoom (id, value) {
    this.__mixpanelTrackEvent('Project questions select room id value: ', {
      id,
      value
    });
  }
  trackGetStartedQuiz ({stepNum}) {
    this.__mixpanelTrackEvent('Get Started Quiz', {stepNum});
    if (window.fbq) {
      window.fbq('trackCustom', `GSQ-${stepNum}`);
    }
  }
}

const modsyMixpanel = new ModsyMixpanelImp();
export default modsyMixpanel;
